import { useMemo } from 'react';

import { useContentfulContentTypeEntry } from '@order/Contentful';

import type { Asset } from 'contentful';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Returns global Contentful settings and assets for the Order app, such as
 * seasonal brand accents shared across multiple screens.
 */
export const useGlobalContent = () => {
  const contentfulResponse = useContentfulContentTypeEntry<GlobalContentFields>({
    contentType: GLOBAL_CONTENT_TYPE,
  });

  // ─── Derived ─────────────────────────────────────────────────────────────

  const mappedFields = useMemo<MappedGlobalFields>(
    () => ({
      brandIcon: contentfulResponse.data?.fields?.brandIcon,
    }),
    [contentfulResponse.data],
  );

  return {
    fields: mappedFields,
    fetching: contentfulResponse.fetching,
  };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const GLOBAL_CONTENT_TYPE = 'global';

// ─── Types ───────────────────────────────────────────────────────────────────

type GlobalContentFields = {
  brandIcon?: Asset;
};

type MappedGlobalFields = {
  brandIcon: Asset | undefined;
};
